import useSWR from "swr";
import { superPacksClient } from "../clients";
import { Superpack } from "../types";

const fetcher = async (): Promise<Superpack[]> => {
  try {
    const { data } = await superPacksClient.getSuperPacks();
    return data;
  } catch (err) {
    throw err;
  }
}

export const useSuperPacks = () => {
  const { data, error, isValidating, mutate } = useSWR(`v1/superpacks`, fetcher, {
    fallbackData: [],
  });

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  }
}
